var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKInverted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119 84",
    style: {
      enableBackground: "new 0 0 119 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D61983;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.4,18.6V5.9c0,0-33.8,8.1-45,8.1c-11,0-43.8-8.1-43.8-8.1v12.7c0,0,32.9,8.1,43.8,8.1 C69.7,26.7,103.4,18.6,103.4,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.7,57.8c-0.1,0-0.2,0-0.2,0v-0.5l-41.2-31h-6.5l-38.9,32C16,58,15,57.8,14,57.8c-5.4,0-9.7,4.4-9.7,9.7 c0,5.4,4.3,9.7,9.7,9.7c4.6,0,8.5-3.3,9.5-7.6l35.9-30.1l34.7,26.7c0,0.5-0.1,0.9-0.1,1.3c0,5.4,4.3,9.7,9.7,9.7 c5.3,0,9.7-4.3,9.7-9.7C113.4,62.2,109,57.8,103.7,57.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKInverted);
export default __webpack_public_path__ + "static/media/k_inverted.436533947706f7dc03d8acf6f3235a13.svg";
export { ForwardRef as ReactComponent };